import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import { useRef } from "react";
import Spinner from "./Spinner";
import { confirmAlert } from "react-confirm-alert";


export default function UploadButton(props) {
    const { onSellect, onlytype, multiple, filename, type } = props;
    const { user } = useSelector((state) => state.auth)
    const fileUpload = useRef(null);
    const [refreshFile, setRefreshFile] = useState(false)
    const [nameFile, setNameFile] = useState('')
    const [uploading, setUploading] = useState(false)
    const [listFile, setListFile] = useState([])

    const convertImageToBlobAfterResize = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    const maxSize = 2048;
                    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;
                    const ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    const outputType = file.type === "image/png" ? "image/png" : "image/jpeg";
                    canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("Không thể resize ảnh")), outputType, 1);
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    };

    const uploadProfilePic = (e) => {
        const fileloads = e.target.files;
        if (!fileloads || fileloads.length === 0) return;

        const list_file = [];
        setUploading(true);

        const uploadPromises = Object.keys(fileloads).map(async (key) => {
            let fileload = fileloads[key];

            // 👇 lấy tên file hiển thị
            const value = e.target.value.split("\\");
            setNameFile(value.slice(-1)[0]);

            let file_name = filename ? filename.replace('/', ".") : fileload.name;
            if (onlytype && key >= 1) {
                file_name = file_name.replace(onlytype, '_' + key + onlytype);
            }

            try {
                // 👇 Nếu là ảnh, resize trước khi upload
                if (fileload.type.startsWith("image/")) {
                    fileload = await convertImageToBlobAfterResize(fileload);
                }

                const formData = new FormData();
                formData.append("file", fileload, file_name);
                formData.append("type", type);
                formData.append("name", "file");
                formData.append("filename", file_name);
                formData.append("changename", filename ? 0 : 1);
                formData.append("folder", 0);

                const res = await Axios.post(URL_LIST_ALL + "fileupload", formData, user.config);

                if (res.data.status === "success") {
                    list_file.push(res.data.message);
                    setListFile((prev) => [...prev, res.data.message]);
                } else {
                    confirmAlert({
                        title: "Lỗi",
                        message: res.data.message,
                        buttons: [{ label: "OK" }],
                    });
                }
            } catch (err) {
                console.error("Upload error:", err);
            }
        });

        Promise.all(uploadPromises).then(() => {
            setUploading(false);
            setRefreshFile(!refreshFile);
        });
    };

    useEffect(() => {

        if (listFile && listFile.length > 0) onSellect(listFile)
    }, [listFile])

    const handleUpload = () => {
        fileUpload.current.click()
    };

    return (
        <div className="upload-modal height32 d-flex">
            <div className="input-group mr-2" onClick={() => handleUpload()}>
                <input type="file" ref={fileUpload} onChange={uploadProfilePic} className="d-none" accept={onlytype ? onlytype : '*'} multiple={multiple ? multiple : false} />
                <button className="btn btn-sm btn-info" type="button">Chọn file</button>
                <input type="text" className="form-control height32" placeholder="Tải lên..." readOnly value={nameFile} />
            </div>
            {uploading && <Spinner />}
        </div >);
}
//https://github.com/elrumordelaluz/reactour